<template lang="pug">
.sv-select-input-list
    .sv-select-input-list__container(
        v-for="(value, index) in valuesWithEmpty"
        :key="index"
    )
        SvSelect.sv-select-input-list__select(
            view="white"
            :value="value[idSelect]"
            :items="items"
            :disabledValues="duplicateItems"
            @input="(id) => changeValueSelect(id, index)"
            placeholder="Выберите из списка"
        )

        SvInput.sv-select-input-list__inputcoords(
            color="graylight"
            :customMask="{regex: '^([-]?[0-9]{1,4})([.][0-9]{1,6})?([,] ([-]?[0-9]{1,4}))([.][0-9]{1,6})?$', placeholder: '', showMaskOnHover: false, showMaskOnFocus: false}"
            :value="value.coordinatesString"
            :withIcon="false"
            :class="{ 'sv-select-input-list--with-remove': value.coordinatesString || value[idSelect] || value[textInput] }"
            @input="(v) => changeCoordinatesInput(v, index)"
            @blur="(v) => changeCoordinatesBlur(v, index)"
            placeholder="Геокоординаты"
        )

        SvInput.sv-select-input-list__input(
            color="graylight"
            :value="value[textInput]"
            :withIcon="false"
            :class="{ 'sv-select-input-list--with-remove': value[textInput] || value[idSelect] }"
            @input="(v) => changeValueInput(v, index)"
            placeholder="Минут"
        )

        SvButton.sv-select-input-list__remove(
            v-if="value[textInput] || value[idSelect] || value.coordinatesString"
            icon
            :prependIcon=`{
                icon: 'trash',
                width: 20,
                height: 20,
                default: '#B7BAC6',
                hover: '#1993EB'
            }`
            view="primary-icon"
            @click="remove(index)"
        )
</template>

<script>
import SvSelect from '@/components/uikit/SvSelect.vue';
import SvButton from '@/components/uikit/SvButton.vue';
import SvInput from '@/components/uikit/SvInput.vue';

export default {
  name: 'SvSelectInputList',

  components: {
    SvSelect,
    SvButton,
    SvInput,
  },

  model: {
    prop: 'values',
    event: 'change',
  },

  data() {
    return {
      latitude: '',
      longitude: '',
      coordinatesString: ''
    }
  },

  props: {
    // Список всех значений
    values: {
      type: Array,
      required: true,
    },

    // Список для селекта
    items: {
      type: Array,
      required: true,
    },

    idSelect: {
      type: String,
      default: 'id',
    },

    nameSelect: {
      type: String,
      default: 'name',
    },

    textInput: {
      type: String,
      default: 'text',
    },
  },

  computed: {
    valuesWithEmpty() {
        console.log('s', [...this.values, {[this.idSelect]: null, [this.textInput]: ''}]);
      return [...this.values, { [this.idSelect]: null, [this.textInput]: '' }];
    },

    duplicateItems() {
      return this.items.filter(
        item => this.values.find(
          v => v[this.idSelect] === item[this.idSelect],
        ),
      );
    },


  },

  methods: {
    changeValueInput(value, index) {
      const copyValues = [...this.values];
      const currentValue = copyValues[index];
      copyValues.splice(index, 1, {
        ...currentValue,
        [this.textInput]: value,
      });
      this.$emit('change', copyValues);
    },


    changeCoordinatesInput(value, index) {
      const copyValues = [...this.values];
      const currentValue = copyValues[index];
      copyValues.splice(index, 1, {
        ...currentValue,
        coordinatesString: value,
      });
      this.$emit('change', copyValues);
    },

    changeCoordinatesBlur(value, index) {
      const copyValues = [...this.values];
      const currentValue = copyValues[index];
      const coordinates = value.split(', ');

      copyValues.splice(index, 1, {
        ...currentValue,
        latitude: coordinates[0] || '',
        longitude: coordinates[1] || ''
      });
      this.$emit('change', copyValues);
    },

    changeValueSelect(value, index) {
      const copyValues = [...this.values];
      const currentValue = copyValues[index];
      copyValues.splice(index, 1, {
        ...currentValue,
        [this.idSelect]: value,
      });
      this.$emit('change', copyValues);
    },

    remove(index) {
      const temp = this.values.slice();
      temp.splice(index, 1);
      this.$emit('change', temp);
    },
  },
};
</script>

<style lang="scss" scoped>
.sv-select-input-list__container {
  margin-bottom: 15px;
  &:last-child {
    margin-bottom: 0;
  }
}
.sv-select-input-list {
    // &--with-remove {
    //     margin-bottom: 15px;
    // }

    &__container {
        display: flex;
    }

    &__select {
        width: 311px;
        margin-right: 10px;
    }

    &__input {
        width: 84px;
        margin-right: 10px;
    }

    &__inputcoords {
        width: 188px;
        margin-right: 10px;
    }
}
</style>
